module.exports = __webpack_public_path__ + "static/MatthewsResume-50c735a77df32496d1ecc35f576c51f7.pdf";